import { useState } from "react";
import CharacterHeader from "./CharacterHeader";
import CustomizationCategories, {
  DEFAULT_ACTIVE_CATEGORY,
} from "./categories/CustomizationCategories";
import { CustomizationCategory } from "../character.types";

import Face from "./categories/Face/Face";
import Body from "./categories/Body/Body";
import Identity from "./categories/Identity/Identity";
import Hair from "./categories/Hair/Hair";
import Beard from "./categories/Beard/Beard";
import { CharacterProvider } from "../providers/CharacterProvider";

export interface CharacterCustomizationProps {
  className?: string;
  titleWords?: { text: string; isHighlighted?: boolean }[];
  description?: string;
}

const CharacterCustomization = ({
  className = "",
  titleWords = [
    { text: "Character" },
    { text: "creator", isHighlighted: true },
  ],
  description = "A place where you can build your own style and flex it every day with your cool pants kek.",
}: CharacterCustomizationProps) => {
  const [activeCategory, setActiveCategory] = useState<CustomizationCategory>(
    DEFAULT_ACTIVE_CATEGORY,
  );

  return (
    <CharacterProvider>
      <div className={`h-screen p-10 relative gilroy-font ${className}`}>
        <div className="h-full flex flex-col space-y-4">
          <CharacterHeader
            titleWords={titleWords}
            description={description}
            className="max-w-[450px]"
          />
          <main className="h-full flex items-stretch space-x-5 max-w-[500px] 1440px:max-w-[650px] min-h-0">
            <CustomizationCategories
              onCategoryClick={setActiveCategory}
              activeCategoryId={activeCategory?.id}
              className="h-full"
            />

            <section className="w-full h-full overflow-y-auto min-h-0 scrollbar-1 pr-4">
              <div>{activeCategory?.id === "identity" && <Identity />}</div>
              <div>{activeCategory?.id === "face" && <Face />}</div>
              <div>{activeCategory?.id === "body" && <Body />}</div>
              <div>{activeCategory?.id === "hair" && <Hair />}</div>
              <div>{activeCategory?.id === "beard" && <Beard />}</div>
            </section>
          </main>
        </div>

        <div className="absolute top-0 left-0 w-full h-full max-w-[60%] bg-gradient-to-r from-[#0b0e16]/80 to-transparent z-[-1]"></div>
      </div>
    </CharacterProvider>
  );
};

export default CharacterCustomization;
